export default __webpack_public_path__ + "static/Group-05ee8c8d9d8934a9eac5866e176ccd20.png";